"use client";

import React, { useState } from "react";
import { clsx } from "clsx";
import { usePathname, useRouter } from "i18n/routing";
import ArrowIcon from "public/icons/arrow-icon.png";
import GlobeIcon from "public/icons/globe-icon.png";
import CheckIcon from "public/icons/check-icon.png";

import { Body } from "components/parts/Typography";
import {
  Option,
  OptionsContainer,
  SelectedContainer,
  SelectorContainer
} from "./styles";
import type { Locale } from "i18n/constants";
import { LANGUAGES } from "i18n/constants";
import Image from "next/image";
import { useLocale } from "next-intl";

const LanguageSwitcher = ({ center = false }) => {
  const router = useRouter();
  const locale = useLocale();
  const pathname = usePathname();

  const setLocale = (locale: Locale) => {
    setOptionsVisible(false);
    router.push(pathname, {
      locale
    });
  };

  const language = LANGUAGES[locale as Locale];
  const [optionsVisible, setOptionsVisible] = useState(false);

  return (
    <SelectorContainer>
      <SelectedContainer onClick={() => setOptionsVisible((prev) => !prev)}>
        <Image src={GlobeIcon} alt="Globe icon" height={20} width={20} />
        <Body size="md" as="span" semiBold m="0 13px 0 10px">
          {language?.includes(" (")
            ? language.slice(0, language.indexOf(" ("))
            : language}
        </Body>
        <Image
          src={ArrowIcon}
          alt="Caret icon"
          width={14}
          height={9}
          className={clsx(
            "transition-transform",
            !optionsVisible && "rotate-180"
          )}
        />
      </SelectedContainer>

      <OptionsContainer isVisible={optionsVisible} center={center}>
        {Object.keys(LANGUAGES).map((localeKey) => (
          <Option
            key={localeKey}
            onClick={() => setLocale(localeKey as Locale)}
          >
            {localeKey === locale && (
              <Image
                src={CheckIcon}
                alt="checkmark icon"
                height={13}
                width={17}
              />
            )}
            <Body size="sm" ml="40px" mb="0">
              {LANGUAGES[localeKey as Locale]}
            </Body>
          </Option>
        ))}
      </OptionsContainer>
    </SelectorContainer>
  );
};

export default LanguageSwitcher;
